<template>
    <div v-show="isActive">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            name: {
                required: true
            },
            selected: {
                default: false
            },
            href: {
                default: '#'
            }
        },

        data() {
            return {
                isActive: false
            };
        },

        methods: {
            updateSwiper() {
                this.$nextTick(() => $helpers.updateSwiper(this.$el));
            },

            collapse(height) {
                if (this.$el.clientHeight > height) {
                    this.$el.style.height = height + 'px'
                    this.$el.classList.add('tabs__item--collapsed')
                    this.$el.addEventListener('click', () => {
                        this.$parent.runEvent('расткрытие ' + this.name)

                        this.$el.style.height = 'auto'
                        this.$el.classList.remove('tabs__item--collapsed')
                    })
                }
            }
        },

        mounted() {
            this.isActive = this.selected;

            this.updateSwiper();
        }
    }
</script>